// 外域数据路由
export default {
    path: 'tdc',
    component: () => import('@/components/RouterView'),
    redirect: 'noRedirect',
    meta: {title: '外域数据'},
    children: [{
        path: 'activity',
        component: () => import('@/components/RouterView'),
        redirect: '/tdc/activity/analysis',
        meta: { title: '外域演出'},
        children: [
			{
				path: 'analysis',
				component: () => import('@/views/tdc/activity/analysis/index'),
				meta: { title: '数据汇总',activePage: '/tdc/activity'}
			}			
		]
		},
		// {
		//     path: 'linklist',
		//     component: () => import('@/components/RouterView'),
		//     redirect: '/tdc/linklist',
		//     meta: { title: '快链数据'},
		//     children: [
		//         {
		//             path: '',
		//             component: () => import('@/views/tdc/linklist/index'),
		//             meta: {title: '快链数据'},
					
		//         }
				
		//     ]
		// }
	]
}